import React from 'react';
import SectionMessage from '@atlaskit/section-message';
import { HelpContent } from '@css-xp/ppc-common';

export const InvalidExistingEntitlementMessage: React.FC<{ message?: string }> = ({ message }) => {
  return (
    <SectionMessage
      title="You've selected a different billing profile"
      appearance="error"
      testId="invalid-existing-entitlement-message"
    >
      <p className="not-allowed-message">
        {/*{renderErrorMessage(message ?? 'All existing entitlements must belong to the same billing profile. ')}*/}
        <HelpContent
          contentPrefix={`${
            message ?? 'All products and apps must belong to the same billing profile. '
          } Still having trouble? Contact`}
        />
      </p>
    </SectionMessage>
  );
};
